import {
	DRAWER_FLOAT,
	DRAWER_HALF,
	DRAWER_MAXIMIZE,
	DRAWER_MINIMIZE
} from '../Types/filesDrawerTypes';

export const maximizeFilesDrawer = () => ({
	type: DRAWER_MAXIMIZE
});
export const minimizeFilesDrawer = () => ({
	type: DRAWER_MINIMIZE
});
export const halfFilesDrawer = () => ({
	type: DRAWER_HALF
});
export const floatFilesDrawer = () => ({
	type: DRAWER_FLOAT
});
